import { globalEndpoints } from './global.constants';

export const BASE_URL = globalEndpoints.REACT_APP_SERVER_URL;
export const RECAPTCHA_CLIENT_SECRET = globalEndpoints.REACT_APP_RECAPTCHA_CLIENT_SECRET;

// --- Bank Accounts
export const API_GET_COMPANY_BANK_ACCOUNTS = '/bank-accounts/company/:companyId';
export const API_ADD_BANK_ACCOUNT = '/bank-accounts/create';

// --- Altshuler Accounts
export const API_GET_COMPANY_ALTSHULER_ACCOUNTS = '/altshuler-accounts';

// --- Altshuler Convert
export const API_GET_CONVERSION_RATE = '/convert/rates';
export const API_DO_CONVERT = '/convert/create';
export const API_GET_CONVERT_DATES = '/convert/dates';
export const API_GET_CONVERT_BY_ID = '/convert/get-convert-by-id';

// --- Balances
export const API_ADD_BALANCE_REQUEST = '/balances/create-add-balance';
export const API_CREATE_ADD_DIGITAL_BALANCE = '/balances/create-add-digital-balance';
export const API_GET_ALTSHULER_SUGGESTED_ACCOUNT = '/balances/company/:companyId/suggested-account';
export const API_GET_COMPANY_BALANCES = '/balances/:companyId/balances';
export const API_SEND_WITHDRAWAL_REQUEST = '/balances/funds-withdrawal';
export const API_GET_BALANCES_ACTIVITIES = '/balances/:companyId/activity';
export const API_GET_BALANCE_BY_ID = '/balances/get-balance-by-id/:balanceId';
export const API_GET_BALANCES_BY_DATE_RANGE = '/balances/:companyId/activity-converted-report';
export const API_HAS_RECENT_DIGITAL_BALANCE_ADDITIONS = '/balances/has-recent-digital-balance-additions';

// --- Pending Requests
export const API_GET_OPEN_REQUESTS = '/requests/open/company/:companyId';

export const API_VALIDATE_BENEFICIARY = 'foo';
export const API_BENEFICIARY_WC = '/beneficiaries/create';
export const API_BENEFICIARY_CREATION = '/beneficiaries/complete-beneficiary-creation';

export const API_LOAD_BENEFICIARIES = '/beneficiaries/get-company-beneficiaries';
export const API_GET_BENEFICIARY_PAYMENTS = '/beneficiaries/get-required-details';
export const API_VALIDATE_BENEFICIARY_BANK_ACCOUNT = '/beneficiaries/validate';
export const API_DELETE_BENEFICIARY = '/beneficiaries/delete';
export const API_EDIT_BENEFICIARY_NOTE = '/beneficiaries/edit-note';
export const API_SIGN_BENEFICIARY = '/beneficiaries/sign';
export const API_REJECT_BENEFICIARY = '/beneficiaries/reject';
export const API_GET_PAYMENT_CATEGORIES = '/company/:companyId/allowed-payment-categories/tree';

export const API_VALIDATE_BALANCE = 'bar';
export const API_GET_COUNTRIES = '/dictionary/allowed-countries';
export const API_GET_CURRENCY = '/dictionary/allowed-currencies';
export const API_GET_BANK_LIST = '/dictionary/bank-list';
export const API_GET_CURRENCY_PAIRS = '/dictionary/currency-pairs';
export const API_GET_COUNTRIES_INCLUDE_FORBIDDEN = '/dictionary/all-countries';
export const API_GET_PAYMENT_PURPOSE = '/dictionary/payment-purpose';

// --- login
export const API_SET_CONTACT_LOGIN_TIME = '/contact/set-contact-login-time';

// --- settings Page
export const API_GET_COMPANY_INFO = '/company/:companyId/company';
export const API_SET_COMPANY_PLAN = '/company/set-plan';
export const API_UPDATE_CONTACT_NAME = '/contact/update/name';
export const API_UPDATE_CONTACT_EMAIL = '/contact/update/email';
export const API_UPDATE_CONTACT_PHONE = '/contact/update/phone';
export const API_UPDATE_CONTACT_LANGUAGE = '/contact/update/language';
export const API_UPDATE_CONTACT_PASSWORD = '/contact/update/password';
export const API_CHECK_SECURITY_QUESTION = '/contact/update/password';

// --- Contacts
export const API_CONTACT_SUPPORT = '/contact/contact-support';
export const API_GET_WITHDRAWAL_REQUESTS = '/contact/contact-support/:companyId/requests';
export const API_GET_COMPANY_CONTACTS = '/contact/company';
export const API_GET_CONTACT_COMPANIES = '/contact/related-companies';
export const API_CONTACT_APPROVALS = '/contact/terms-and-marketing';

// --- System Messages
export const API_SYSTEM_MESSAGES_PENDING = '/system-messages/pending';
export const API_SYSTEM_MESSAGES_CONFIRM = '/system-messages/confirm';

// --- Payment
export const API_GET_PAYMENT_FEES = '/payments/fees';
export const API_VALIDATE_PAYMENT = '/payments/validate';
export const API_CREATE_PAYMENT = '/payments/create';
export const API_AVAILABLE_PAYMENT_DAYS = '/payments/available-payment-days';
export const API_GET_BENEFICIARY_PAYMENTS_HISTORY = '/payments/get-beneficiary-payments';
export const API_SIGN_PAYMENT = '/payments/sign';
export const API_REJECT_PAYMENT = '/payments/reject';
export const API_GET_PAYMENT_BY_ID = '/payments/get-payment-by-id';
export const API_UPLOAD_PAYMENT_FILE = '/payments/upload-payment-file';

// Refund
export const API_GET_REFUND_BY_ID = '/balances/refunds/:id';

// Activity
export const API_GET_COMPANY_ACTIVITIES = '/activities';
export const API_GET_COMPANY_BALANCES_ACTIVITIES = '/balances-activities';

// Reports
export const API_GET_REPORTS_CATALOG = '/reports/catalog';
export const API_DOWNLOAD_REPORT = '/reports/render';

// Notifications
export const API_GET_NOTIFICATIONS = '/notifications/:companyId/notifications';
export const API_UPDATE_NOTIFICATIONS = '/notifications/mark-as-read';

// Files
export const API_GET_FILE = '/file/read/:key/:companyId';

//Dashboard - rates graph from bank of israel
export const API_GET_CURRENCY_RATE =
	'https://edge.boi.gov.il/FusionEdgeServer/sdmx/v2/data/dataflow/BOI.STATISTICS/EXR/1.0/';

//Plans
export const API_UPDATE_COMPANY_PLAN = '/company/set-plan';
export const API_GET_ALL_PLANS = '/plan/available-plans';
export const API_GET_PLAN_CURRENCIES = '/plan/currencies';

//Company
export const API_GET_COMPANY_CREDIT_CARD_URL = '/company/credit-card-link';

//Content
export const API_GET_TRANSLATIONS = '/content/translations/:languageCode';
export const API_GET_AVAILABLE_LANGUAGES = '/content/active-languages';

//Feature Flags
export const API_GET_ALL_FEATURE_FLAGS = '/feature-flags/all';

//System Settings
export const API_GET_ALL_SYSTEM_SETTINGS = '/system-settings/all';
